import { render, staticRenderFns } from "./Companies_1.vue?vue&type=template&id=7b224308&"
import script from "./Companies_1.vue?vue&type=script&lang=js&"
export * from "./Companies_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Companies_1.vue"
export default component.exports